import { render } from "./indexLayer.vue?vue&type=template&id=0a14fb9a&scoped=true"
import script from "./indexLayer.vue?vue&type=script&lang=js"
export * from "./indexLayer.vue?vue&type=script&lang=js"

import "./indexLayer.vue?vue&type=style&index=0&id=0a14fb9a&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a14fb9a"]])

export default __exports__